import * as React from 'react';

import styled from '@emotion/styled';
import { Box, themeGet } from '@lightspeed/flame/Core';
import { IconChevronRight } from '@lightspeed/flame/Icon/ChevronRight';

const StyledLink = styled.a`
  display: block;
  transition: transform 0.2s ease-in-out !important;
  &.active {
    transform: rotate(90deg);
  }
  &:hover {
    svg {
      fill: ${themeGet('colors.secondary')};
    }
  }
  &:focus {
    outline: none;
  }
`;

interface ShowHideToggleProps {
  isExpanded: boolean;
  onClick: () => void;
}

const ExpandedToggle: React.FC<ShowHideToggleProps> = ({ isExpanded, onClick }) => {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    onClick();
  };

  return (
    <Box style={{ position: 'absolute', top: '8px', right: '15px' }}>
      <StyledLink
        href="#"
        onClick={handleClick}
        data-test="expanded-toggle-button"
        className={isExpanded ? 'active' : ''}
      >
        <IconChevronRight />
      </StyledLink>
    </Box>
  );
};

export default ExpandedToggle;
